export default __webpack_public_path__ + "static/media/infra.4d551794.webp";